import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import './PageWrap.module.scss'

const PageWrap = ({ children, nopadding = false }) => (
  <div styleName={classnames('wrap', { 'nopadding': nopadding === true })}>
    {children}
  </div>
)

PageWrap.propTypes = {
  children: PropTypes.any
}

export default PageWrap



// WEBPACK FOOTER //
// ./src/components/PageWrap/PageWrap.js